import React from "react";
import styles from "./AnimatedStatusText.module.scss";
import {useAnimatedStatus} from "./useAnimatedStatus";
import {AnimatedStatusType} from "./types";


const StatusSpan: React.FC<{ text: string; isActive: boolean; className: string; type: string }> = ({
                                                                                                        text,
                                                                                                        isActive,
                                                                                                        className,
                                                                                                        type
                                                                                                    }) => (
    <div className={`${styles.statusWrapper} ${isActive ? styles.active : ""}`}
         data-testid={`status-wrapper-${type}`}>
        <span className={`${styles.animatedText} ${className}`}>
            {text.split("").map((char, index) => (
                <span key={`${type}-${index}`} style={{"--index": index} as React.CSSProperties}>
                    {char === " " ? "\u00A0" : char}
                </span>
            ))}
        </span>
    </div>
);

interface Props {
    status: AnimatedStatusType;
    loadingText?: string;
    successText?: string;
    errorText?: string;
}

export const AnimatedStatusText: React.FC<Props> = ({
                                                        status,
                                                        loadingText = "Processing...",
                                                        successText = "Success!",
                                                        errorText = "Error occurred",
                                                    }) => {

    const {activeStatus} = useAnimatedStatus(status)


    return (
        <div className={styles.container}>
            <StatusSpan
                type="loading"
                text={loadingText}
                isActive={activeStatus === "loading"}
                className={styles.statusLoading}
            />
            <StatusSpan
                type="success"
                text={successText}
                isActive={activeStatus === "success"}
                className={`${styles.statusSuccess} ${styles.staticText}`}
            />
            <StatusSpan
                type="error"
                text={errorText}
                isActive={activeStatus === "error"}
                className={`${styles.statusError} ${styles.staticText}`}
            />
        </div>
    );
};